export default __webpack_public_path__ + "static/media/test-blue.73f0018d.svg";